export default __webpack_public_path__ + "static/media/icon-formacao.da08b1ea.svg";